export default __webpack_public_path__ + "static/media/notification.86f61b2d.svg";